/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import router from '../router';
import store from '../store';

import authActions from '../store/actions/auth';
import errorActions from '../store/actions/error';
import namespace from '../store/namespace';

axios.defaults.baseURL = 'https://service.laportal.net/api/';

const setup = () => {
    axios.interceptors.request.use((config) => {
        store.dispatch(`${namespace.ERROR}/${errorActions.REMOVE_ERROR}`);
        const accessToken = store.getters[`${namespace.AUTH}/AccessToken`];

        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }

        const hasCurrentOrg = store.getters[`${namespace.ORGANIZATION}/HasOrganization`];

        if (hasCurrentOrg) {
            const currentOrg = store.getters[`${namespace.ORGANIZATION}/Organization`];

            config.headers.common['X-Current-Org'] = currentOrg;
        }

        const hasUser = store.getters[`${namespace.USER}/HasUser`];

        if (hasUser) {
            const languageCode = store.getters[`${namespace.USER}/LanguageCode`];
            config.params = config.params || {};
            config.params.culture = languageCode;
        }

        config.headers.common['Content-Type'] = 'application/json';

        return config;
    }, (error) => { throw error; });

    axios.interceptors.response.use(
        response => response,
        async (error) => {
            if (!error.response) {
                throw error;
            }

            const { config, response } = error;

            const originalRequest = config;

            if (response.status !== 401) {
                throw error;
            }

            if (error.config.url.includes('refreshtoken')) {
                router.push('/login');
                throw error;
            }

            if (!originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    await store.dispatch(`${namespace.AUTH}/${authActions.REFRESH_TOKEN}`);
                    const isAuthenticated = store.getters[`${namespace.AUTH}/IsAuthenticated`];

                    if (isAuthenticated) {
                        const accessToken = store.getters[`${namespace.AUTH}/AccessToken`];
                        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
                        return await axios(originalRequest);
                    }
                } catch (e) {
                    router.push('/login');
                    throw error;
                }
            }

            throw error;
        },
    );
};

export default setup;
